import gql from 'graphql-tag'

export const searchResultsQuery = gql`
  query SearchProduct($search: String!) {
    productSearch(text: $search) {
      id
      code
      yotpoId: yotpo_id
      name
      type: name
      comingSoon: coming_soon
      description: short_description
      isTopProduct
      onlyProDesign: only_pro_design
      intakeAdmin: intake_admin
      customizable: design_center
      retailMen: men_retail
      retailWomen: women_retail
      category_id
      genders {
        id
        name: gender
      }
      priceRange {
        quantity
        price
        abbreviation
        shortName: short_name
      }
      images: pictures {
        front: front_image
        thumbnail
        color_id
        preview
      }
      colors {
        id
        name
        image
      }
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        countryName: country_name
        countryCode: country_code
      }
      reseller {
        id
        status
        comission
        inline
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SearchResults/data.ts